import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { ConfigService } from 'src/app/provider/config.service';
import _ from 'lodash';
// import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.page.html',
  styleUrls: ['./terms-and-conditions.page.scss'],
  standalone: false,
})
export class TermsAndConditionsPage implements OnInit, OnDestroy {
  public settings?: any;
  private appSettingsSubscription?: Subscription;
  content?: any;
  constructor(public modalCtrl: ModalController, private apiService: ApiService, private configService: ConfigService) {}

  ngOnInit() {
    this.appSettingsSubscription = this.configService.appSettings$.subscribe((currentSettings: any) => {
      this.settings = currentSettings;
    });
    this.apiService?.get(endpoints.cms).subscribe((res: any) => {
      if (this.settings?.appLanguage == 'ar') {
        this.content = _.filter(res.data.pages, (val: any) => val.title == 'Terms & Conditions')[0]?.a_content;
      } else {
        this.content = _.filter(res.data.pages, (val: any) => val.title == 'Terms & Conditions')[0]?.content;
      }
    });
  }
  ngOnDestroy() {
    if (this.appSettingsSubscription) {
      this.appSettingsSubscription?.unsubscribe();
    }
  }
  ionViewWillEnter() {
    // this.configService.getAppSettings()
    //     .then((settingData: any) => {
    //         this.settings = JSON.parse(settingData);
    //     }
    //     );
  }
  acceptModal = () => {
    this.modalCtrl?.dismiss(true, 'close');
  };
  closeModal = () => {
    this.modalCtrl?.dismiss(false, 'cancel');
  };
}
